<div class="expanded-panel-header gray">Syndications Notes</div>

<p>{{detail.syndications_notes}}</p>
